import Application from "../../Application";
import withStore, {
  TLoadingAwarePresenter,
  TPresentable
} from "../../core/presenter/withStore";
import { ICaseLawDocument } from "../model/CaseLawDocument";
import { IOrganisation } from "../../organisations/model/Organisation";
import CaseLawDocumentPresentationModel, {
  TCaseLawDocumentPresentationModel
} from "./model/CaseLawDocumentPresentationModel";
import { ICourtCase } from "../model/CourtCase";
import { IUser } from "../../user/model/User";
import {
  IDocumentType,
  TDocumentType
} from "../../documentTypes/model/DocumentType";

export interface TCaseLawDocumentListPresenter extends TLoadingAwarePresenter {
  caseLawDocuments: TCaseLawDocumentPresentationModel[];
  organisations: IOrganisation[];
  caseLawDocumentTypes: TDocumentType[];
  courtCaseList: ICourtCase[];
  user?: IUser;
}
export interface ICaseLawDocumentListPresenter
  extends TCaseLawDocumentListPresenter,
    TPresentable {
  loadAllCaseLawDocuments(caseLawDocuments: ICaseLawDocument[]): void;
  loadReferenceValues(
    caseLawDocumentTypes: IDocumentType[],
    organisations: IOrganisation[]
  ): void;
  createNewCaseLawDocument(): void;
  showCaseLawDocumentDetails(id: number): void;
}
const defaultState: TCaseLawDocumentListPresenter = {
  caseLawDocuments: [],
  organisations: [],
  caseLawDocumentTypes: [],
  courtCaseList: []
};
const CaseLawDocumentListPresenter = withStore<
  ICaseLawDocumentListPresenter,
  TCaseLawDocumentListPresenter
>(
  ({
    application,
    store,
    loader,
    translate
  }): ICaseLawDocumentListPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TCaseLawDocumentListPresenter>();
    const loadReferenceValues = (
      caseLawDocumentTypes: IDocumentType[],
      organisations: IOrganisation[]
    ) => {
      _store.update({ caseLawDocumentTypes, organisations });
    };
    loader.start("caseLawDocumentLoader");
    const loadAllCaseLawDocuments = (caseLawDocuments: ICaseLawDocument[]) => {
      const { organisations, caseLawDocumentTypes } =
        _store.getState<TCaseLawDocumentListPresenter>();
      let caseLawDocumentList = (caseLawDocuments || []).map((item) => {
        const caseLawDocumentType = caseLawDocumentTypes?.find(
          (value) => value.id === item.documentTypeId
        );
        const organisation = organisations?.find(
          (value) => value.id === item.organisationId
        );
        const selectedLanguage = _store.getState<any>().selectedLanguage;
        const summary = item.summaryTranslations.find(
          (item) => item.languageId === selectedLanguage.id
        )?.summaryTranslation;

        return CaseLawDocumentPresentationModel(
          item,
          caseLawDocumentType,
          organisation,
          summary
        );
      });
      const user = _store.getState<any>().user;
      _store.update({
        caseLawDocuments: caseLawDocumentList,
        user
      });
      loader.stop("caseLawDocumentLoader");
    };

    const createNewCaseLawDocument = () => {
      return _application.navigator.push({
        pathname: `/case-law-documents/new`
      });
    };

    const showCaseLawDocumentDetails = (id: number) => {
      return _application.navigator.push({
        pathname: `/case-law-documents/${id.toString()}/details`
      });
    };

    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      loadAllCaseLawDocuments,
      loadReferenceValues,
      createNewCaseLawDocument,
      showCaseLawDocumentDetails
    };
  },
  defaultState
);
export default CaseLawDocumentListPresenter;
